import React from "react";
import InputMask from "react-input-mask";

import { Modal } from "react-bootstrap";

export const OptionalTime = ({ show, onHide }) => {
	return (
		<Modal show={show} onHide={() => onHide()} dialogClassName="modal-m modal-dialog modal-fix modal-search has-footer">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Thời gian</h5>
			</Modal.Header>
			<Modal.Body>
            <div className="modal-body modal-input-body calendercs">
                {/* <div className="time-choose__item">
                <p className="title-time">Nhận xe</p>
                <p className="active-time">16/11/2023</p>
                </div> */}
                <div className="time-choose__item is-focused">
                <p className="title-time">Trả xe</p>
                    <InputMask
                        name="ip_dob"
                        mask="99-99-9999"
                        // defaultValue={`${ip_dob}`}
                        // onChange={this.handleInputChange}
                    />
                </div>
                <div className="error-content"> 
                <div className="wrap-svg"> 
                    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" fill="none">
                    <path d="M7 4.2793V7.38597" stroke="#F04438" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7 9.71973C7.27614 9.71973 7.5 9.49587 7.5 9.21973C7.5 8.94358 7.27614 8.71973 7 8.71973C6.72386 8.71973 6.5 8.94358 6.5 9.21973C6.5 9.49587 6.72386 9.71973 7 9.71973Z" fill="#F04438" />
                    <path d="M6.99967 13.1663C10.4054 13.1663 13.1663 10.4054 13.1663 6.99967C13.1663 3.59392 10.4054 0.833008 6.99967 0.833008C3.59392 0.833008 0.833008 3.59392 0.833008 6.99967C0.833008 10.4054 3.59392 13.1663 6.99967 13.1663Z" stroke="#F04438" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <p className="font-12 text-danger">Ngày không hợp lệ! Vui lòng chọn ngày phù hợp hơn</p>
                </div>
                <div className="wrap-btn"><a className="btn btn--m btn-primary" href>Áp dụng</a></div>
            </div>
			</Modal.Body>
		</Modal>
	);
};
